<div class="variable-palette" [class.expanded]="isExpanded || isExternalExpanded" [class.visible]="isExpanded || isExternalExpanded" #paletteContainer>
  <div class="palette-content" *ngIf="isExpanded || isExternalExpanded">
    <div class="search-container">
      <mat-form-field appearance="outline" class="search-field">
        <input
          matInput
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          [placeholder]="'footers.palette.searchPlaceholder' | translate"
          [attr.aria-label]="'footers.palette.searchVariables' | translate"
        />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
    </div>

    <div class="category-tabs">
      <button mat-button
              type="button"
              *ngFor="let category of visibleCategories"
              [class.active]="activeCategory === category.key"
              (click)="onCategoryChange(category.key)"
              class="category-tab"
              [matTooltip]="category.label | translate"
              matTooltipPosition="below">
        <mat-icon>{{ category.icon }}</mat-icon>
      </button>
    </div>

    <div class="variables-container">
      
      <div class="variables-list" *ngIf="filteredVariables.length > 0; else noVariables">
        <div class="variable-item" 
             *ngFor="let variable of getCategoryVariables(activeCategory)"
             (click)="onVariableClick(variable)"
             (dragstart)="onVariableDragStart($event, variable)"
             draggable="true"
             [matTooltip]="variable.description | translate"
             matTooltipPosition="right"
             matTooltipClass="variable-tooltip">
          
          <div class="variable-icon">
            <mat-icon>{{ variable.icon }}</mat-icon>
          </div>
          
          <div class="variable-info">
            <div class="variable-name">{{ variable.displayName | translate }}</div>
            <div class="variable-code">{{ variable.name }}</div>
          </div>
          
          <div class="variable-actions">
            <mat-icon class="insert-icon">add</mat-icon>
            <mat-icon class="drag-handle">drag_indicator</mat-icon>
          </div>
        </div>
      </div>

      <ng-template #noVariables>
        <div class="no-variables" *ngIf="!showBranchEmptyState()">
          <mat-icon>search_off</mat-icon>
          <p>{{ 'footers.palette.noVariablesFound' | translate }}</p>
        </div>
        <div class="no-variables-button" *ngIf="showBranchEmptyState() && !hasBranchVariables()" >
          <button
          mat-raised-button 
          (click)="navigateToBranchSettings()"
          class="navigate-branch-button">
            <mat-icon>business_center</mat-icon>
            {{ 'footers.palette.createBranches' | translate }}
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div> 